module.exports = __webpack_public_path__ + "static/media/cz.55281a2f.svg";